import type { NextOrderDetailsData } from '@/types'
import OmpNextOrderSkeleton from './OmpNextOrderSkeleton'
import OmpOrderSummarySkeleton from './OmpOrderSummarySkeleton'

interface OmpDetailSkeletonProps {
  data?: NextOrderDetailsData
}

// Both detail pages are a head card (facts + actions) followed by the order summary.
const OmpDetailSkeleton = ({ data }: OmpDetailSkeletonProps) => {
  return (
    <div className="omp-card-list" aria-hidden="true">
      <OmpNextOrderSkeleton data={data} variant="detail" />

      <OmpOrderSummarySkeleton />
    </div>
  )
}

export default OmpDetailSkeleton
